import { isRequestError } from "@prismicio/editor-support/Http"
import { useEffect } from "react"
import { z } from "zod"

import { env } from "../env"

export function getRepositoryName(): string {
  let repositoryName: string | undefined

  if (env.VITE_VERCEL_URL !== undefined) {
    repositoryName = undefined
  } else {
    const labels = location.hostname.split(".")
    repositoryName = labels.length === 3 ? labels[0] : undefined
  }

  if (!repositoryName && window.__repository__) {
    repositoryName = window.__repository__
  }

  repositoryName ??= env.PRISMIC_PAGE_BUILDER_FALLBACK_REPOSITORY_NAME

  if (repositoryName === undefined) {
    throw new Error(
      `Cannot get the repository name from the current \`${location.href}\` location.`,
    )
  }

  return repositoryName
}

export function getBaseUrl(): URL {
  return new URL(import.meta.env.BASE_URL, location.origin)
}

export function getRouterBasename(): string {
  return getBaseUrl().pathname
}

export function useRepositoryMetaTitle(pageName: string) {
  const repositoryName = getRepositoryName()

  useEffect(() => {
    document.title = `${repositoryName} - ${pageName}`
  }, [pageName, repositoryName])
}

const domain = env.PRISMIC_DOMAIN

export function getBaseRepositoryUrl(
  repositoryId: string = getRepositoryName(),
) {
  return `https://${repositoryId}.${domain}`
}

export function isRepositoryLockedError(error: unknown) {
  if (!isRequestError(error)) return false
  if (error.detail.type !== "http") return false
  if (error.detail.status !== 403) return false

  const repositoryLockedErrorSchema = z.object({
    error: z.literal("repository_locked"),
  })

  return repositoryLockedErrorSchema.safeParse(error.detail.body).success
}
